import React, { ReactNode } from "react";
import Box from "@vapor/react-material/Box";

interface UnderlinedBoxProps {
  children: ReactNode;
}

export const UnderlinedBox: React.FC<UnderlinedBoxProps> = ({ children }) => {
  const boxStyles = {
    borderBottom: "1px solid #808080",
    paddingBottom: "6px",
    width: 600,
    marginTop: 7,
    display: "flex",
    justifyContent: "space-between"
  };

  return <Box sx={boxStyles}>{children}</Box>;
};
